<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54.93 79.85">
        <path
            d="M27.6,0C12.5-.13.13,12,0,27.1c-.13,15.09,12,27.46,27.1,27.6h9.49v-10.25h-8.99c-9.43.1-17.19-7.44-17.3-16.9-.1-9.46,7.44-17.19,16.9-17.3h.39c9.43,0,17.09,7.65,17.14,17.09h0v25.18h0c0,9.36-7.63,16.98-16.96,17.09-4.48-.03-8.75-1.83-11.9-5.01l-7.26,7.26c5.03,5.06,11.85,7.94,18.97,7.99h.37c14.91-.21,26.89-12.32,26.97-27.23v-25.97C54.56,11.85,42.43.03,27.6,0Z"
            style="fill: #f55036; stroke-width: 0px"
        />
    </svg>
</template>
